import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import axios from 'axios';
import translations, { LANGUAGES } from '../translations';

const LanguageContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('odelicieuse_lang') || 'fr';
  });

  const changeLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem('odelicieuse_lang', code);
    // Persist on the user profile so downstream notifications (WhatsApp
    // status updates, emails) reach the customer in the right language.
    // Silent no-op for guests (401) and on network errors.
    axios.put(`${API_URL}/api/auth/language`, { language: code }).catch(() => {});
  }, []);

  const t = useCallback((key, params = {}) => {
    const str = translations[lang]?.[key] || translations.fr[key] || key;
    return Object.entries(params).reduce(
      (s, [k, v]) => s.replace(new RegExp(`\\{${k}\\}`, 'g'), v),
      str
    );
  }, [lang]);

  const value = useMemo(() => ({ lang, changeLang, t, languages: LANGUAGES }), [lang, changeLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
